import CreateApiModule from "@/redux/create-api-module";
import { Config } from "@/utils/config.utils";

import { $PhonenumberPrefixesModuleName } from "./phonenumberPrefixes.types";

const { actions } = CreateApiModule(
    $PhonenumberPrefixesModuleName,
    () => `/i18nservice/${Config.general.basestore}/i18n/phoneprefixes`
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
